import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-vehicles-mgmt',
  templateUrl: './vehicles-mgmt.component.html',
  styleUrls: ['./vehicles-mgmt.component.scss']
})
export class VehiclesMgmtComponent {
  @Input() fleetId: string[] = [];
  @Input() fleetName: string = '';
  
  constructor() { }

}
